import React from 'react';
import { FormattedMessage } from 'react-intl';

import { createDictionary } from 'utils/ObjectUtils';

export const MODAL_SOURCE = 'releases-modal';
export const DETAILS_SOURCE = 'releases-details';
export const DASHBOARD_SOURCE = 'releases-dashboard';

export const RELEASE_STATE = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
};

export const RELEASE_TYPE = {
  MOBILE: 'MOBILE',
  WEB: 'WEB',
};

export const RELEASE_TYPE_LABEL = {
  [RELEASE_TYPE.MOBILE]: <FormattedMessage id="page.releases.type.mobile" defaultMessage="Mobile" />,
  [RELEASE_TYPE.WEB]: <FormattedMessage id="page.releases.type.web" defaultMessage="Web" />,
};

export const RELEASE_STATE_LABEL = {
  [RELEASE_STATE.DRAFT]: <FormattedMessage id="audito.model.builder.sections.header.status.DRAFT" defaultMessage="Draft" />,
  [RELEASE_STATE.PUBLISHED]: <FormattedMessage id="audito.model.builder.sections.header.status.OPEN" defaultMessage="Published" />,
  [RELEASE_STATE.ARCHIVED]: <FormattedMessage id="audito.model.builder.sections.header.status.CLOSED" defaultMessage="Archived" />,
};

export const TYPE_OPTIONS = Object.entries(RELEASE_TYPE_LABEL).map(([value, label]) => ({ value, label }));

export const MEDIA_CONFIG_PATH = createDictionary(
  {
    [RELEASE_TYPE.MOBILE]: ['release-mobile', 'note', 'content'],
  },
  ['release-web', 'note', 'content']
);

export const RELEASE_NOTE_NAME_MAX_LENGTH = 80;
export const RELEASE_DESCRIPTION_MAX_LENGTH = 160;
export const RELEASE_NOTE_DESCRIPTION_MAX_LENGTH = 400;
